import { ACTION_SET_PHONE_NUMBER } from './types'

const selectDeliveryMode = ({ rest }, phone) => ({
    payload: { phone },
    type: ACTION_SET_PHONE_NUMBER,
})

export default selectDeliveryMode
